/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Downloads_Dropdown_ExtensionInputs */

const en_downloads_dropdown_extension = /** @type {(inputs: Downloads_Dropdown_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Browser Extension`)
};

const es_downloads_dropdown_extension = /** @type {(inputs: Downloads_Dropdown_ExtensionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensión del navegador`)
};

/**
* | output |
* | --- |
* | "Browser Extension" |
*
* @param {Downloads_Dropdown_ExtensionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const downloads_dropdown_extension = /** @type {((inputs?: Downloads_Dropdown_ExtensionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Downloads_Dropdown_ExtensionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_downloads_dropdown_extension(inputs)
	return en_downloads_dropdown_extension(inputs)
});